import { render, staticRenderFns } from "./IconMaterialFeatures.vue?vue&type=template&id=147a5222&scoped=true&"
import script from "./IconMaterialFeatures.vue?vue&type=script&lang=js&"
export * from "./IconMaterialFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a5222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('147a5222')) {
      api.createRecord('147a5222', component.options)
    } else {
      api.reload('147a5222', component.options)
    }
    module.hot.accept("./IconMaterialFeatures.vue?vue&type=template&id=147a5222&scoped=true&", function () {
      api.rerender('147a5222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconMaterialFeatures.vue"
export default component.exports